export const Z_INDEX_HEADER = 800;
export const Z_INDEX_APP_ALERT = 900;
export const Z_INDEX_MODAL = 1100;
